<template>
  <div>
    <div v-if="attachmentsAndUploads.length" class="row" style="padding-bottom:91px; overflow-y:auto; height:calc(100vh - 169px - 91px)">
      <div v-for="file in attachmentsAndUploads" :key="file.id" class="col-4">
        <div class="pb-4">
          <div class="file border rounded">
            <div class="p-3 font-weight-bolder text-truncate" :title="file.name" style="border-bottom:1px solid var(--border-color); font-size:1rem">{{file.name}} ({{moment(file.item_date || file.updated_at).fromNow()}})</div>
            <file v-if="!file.created_by" :file="file" style="height:120px;" class="bg-light " />
            <file v-else :file="file" style="height:120px;" class="bg-light ">
              <div slot="afterIcon" style="word-break: break-all">
                <!-- {{ file.custom_name || file.name }}
                <small class="d-block" v-if="file.updated_at">
                  {{
                        moment(file.item_date || file.updated_at).fromNow()
                      }}</small> -->
              </div>
              <div slot="afterDetails"></div>
            </file>
            <div class="px-3 pt-3 pb-2 d-flex justify-content-between" style="border-top:1px solid var(--border-color)">
              <a href="javascript:;" class="btn btn-link btn-link-muted">
                <font-awesome-icon :icon="['far', 'eye']" style="font-size:1.2rem" />
              </a>
              <a href="javascript:;" class="btn btn-link btn-link-muted">
                <font-awesome-icon :icon="['far', 'download']" style="font-size:1.2rem" />
              </a>
              <a href="javascript:;" class="btn btn-link btn-link-muted" @click="deleteFile" v-if="file.created_by && file.created_by.practice_id == user.practice.id">
                <font-awesome-icon :icon="['far', 'trash']" style="font-size:1.2rem" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-hint font-weight-normal">No attachments</div>
    <upload :modelId="item.id" v-model="item.uploads" formClass="bg-white border-top p-2 p-sm-2 d-flex align-items-center flex-column" style="position:fixed; bottom: 0; left:550px; width: calc(100vw - 550px);" />
  </div>
</template>

<script>
import { AttachmentApi } from '@/services'
import { mapState } from 'vuex'
import File from '../../files/File.vue'
import Upload from '../../files/Upload.vue'
export default {
  components: {
    File,
    Upload,
  },
  props: {
    item: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      uploads: [],
    }
  },
  computed: {
    ...mapState('auth', ['user']),

    attachmentsAndUploads() {
      return [
        ...this.item.attachments,
        ...(this.item.uploads?.map((s) => (s.success ? s.response : s)) || []),
      ]
    },
  },
  methods: {
    deleteFile() {
      const _this = this
      this.$dialog
        .confirm(
          {
            title: 'Confirm Delete',
            body: 'Are you sure you want to delete this upload?',
          },
          { okText: 'Yes', cancelText: 'No' }
        )
        .then(async () => {
          _this.isDeleting = true
          await AttachmentApi.delete(_this.file.id)
          _this.isDeleting = false
        })
    },
  },
}
</script>

<style scoped lang="scss">
</style>